<template>
  <div class="navbar">
    <router-link to="/index">
      <div class="logo">
        <el-image class="logo-img" fit="contain" :src="logo" />
      </div>
    </router-link>
    <div class="user-profile-content">
      <el-badge
        :value="unReadNum"
        :max="99"
        :hidden="unReadNum == 0"
        class="item"
        :class="{ noticeCount: unreadCount == 0 }"
      >
        <i class="el-icon-message-solid" @click="toNotice"></i>
      </el-badge>
      <el-divider direction="vertical" class="divider"></el-divider>
      <el-dropdown>
        <div class="user-profile-body">
          <div class="user-avatar-container">
            <img
              class="user-avatar"
              :src="
                userInfo.u_avatar
                  ? userInfo.u_avatar
                  : require('../../../assets/moren.png')
              "
            />
            <img
              src="../../../assets/enterprise.png"
              class="attestationIcon"
              v-if="u_cert_status == 1 && u_cert == 1 && cert_type == 24"
            />
            <img
              src="../../../assets/renzheng.png"
              class="attestationIcon"
              v-else-if="u_cert_status == 1 && u_cert == 1"
            />
          </div>
          <span class="user-name">{{ userInfo.u_nickname }}</span>
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item>
            <div class="user-dropdown-item" @click="toEnterprise">
              <img
                src="../../../assets/enterprise.png"
                class="user-dropdown-icon"
              />
              <span class="user-dropdown-item-text">企业认证</span>
              <span class="isEnterprise" v-if="enterpriseData.status == 2"
                >已认证</span
              >
              <span class="notEnterprise" v-else>{{
                enterpriseStatus[enterpriseData.cert_audit_status]
              }}</span>
            </div>
          </el-dropdown-item>
          <el-dropdown-item>
            <router-link to="/user" custom v-slot="{ navigate }">
              <div
                class="user-dropdown-item"
                @click="navigate"
                @keypress.enter="navigate"
                role="link"
              >
                <img src="../../../assets/set.png" class="user-dropdown-icon" />
                <span class="user-dropdown-item-text">设置</span>
              </div>
            </router-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <div class="user-dropdown-item" @click="logout">
              <img
                src="../../../assets/logout.png"
                class="user-dropdown-icon"
              />
              <span class="user-dropdown-item-text">退出</span>
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div
        class="certificationContainer"
        @click="certificationVisible = true"
        v-if="u_cert_status != 1 || u_cert != 1"
      >
        <p>{{ u_cert != 1 ? "实名认证" : "申请认证" }}</p>
        <img src="../../../assets/gengduo.png" />
      </div>
    </div>

    <el-dialog
      :title="u_cert != 1 ? '请完成实名认证' : '请完成职业/机构认证'"
      :visible.sync="certificationVisible"
      class="certificationInfoContainer"
      width="1026px"
    >
      <p class="title" v-if="u_cert != 1">
        应网络实名制要求，完成实名认证后才可以发表文章视频等内容，以保护账号安全。
      </p>
      <div class="borderContainer">
        <div>
          <p class="infoTitle">1、打开“顶端新闻”App</p>
          <p class="info">登录当前账号或扫下方二维码下载“顶端新闻”App</p>
          <img
            src="../../../assets/85d81507ebe84f210b224bf8e02c6d76966336a7fff89e02e5f088ed492cce1f.png"
            class="qrCode"
          />
        </div>
        <div>
          <p class="infoTitle">2、打开“我的”</p>
          <p class="info">
            {{
              u_cert != 1
                ? "点击“实名认证”完成实名认证"
                : "点击“申请认证”完成职业/机构认证"
            }}
          </p>
          <img
            src="../../../assets/shiming@2x.png"
            class="app"
            v-if="u_cert != 1"
          />
          <img src="../../../assets/shenqing@2x.png" class="app" v-else />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { USER_HOST, SWNEWS_HOST } from "../../../constants/apiHosts";
import logo from "../../../assets/logoNew.png";
import { mapState, mapActions } from "vuex";

export default {
  name: "NavBar",
  computed: {
    ...mapState({
      userInfo: (state) => state.common.userInfo,
      unReadNum: (state) => state.common.unReadNum,
    }),
  },
  data() {
    return {
      u_avatar: "",
      u_nickname: "",
      unreadCount: 0,
      logo,
      certificationVisible: false,
      u_cert_status: 1,
      u_cert: 1,
      cert_type: 0,
      enterpriseData: {},
      enterpriseStatus: {
        0: "未认证",
        1: "审核通过",
        2: "审核中",
        3: "审核中",
        4: "审核失败",
      },
    };
  },
  created() {
    this.u_cert_status = localStorage.getItem("u_cert_status");
    this.u_cert = localStorage.getItem("u_cert");
    this.cert_type = localStorage.getItem("cert_type");

    this.getUserInfo().then(() => {
      this.u_cert_status = localStorage.getItem("u_cert_status");
      this.u_cert = localStorage.getItem("u_cert");
      this.cert_type = localStorage.getItem("cert_type");
    });

    this.getUnReadNum();
    this.enterpriseUser();
  },
  methods: {
    ...mapActions("common", ["getUserInfo", "getUnReadNum"]),
    toNotice() {
      this.$router.push({
        path: "/notice",
      });
    },
    logout() {
      this.$axios.post(`${USER_HOST}/login/admin/quit`, {}).then((res) => {
        if (res.data.code == 0) {
          localStorage.removeItem("token");

          this.$router.push({ path: "/login" });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    backFn() {
      this.$storage.setItem("product", JSON.stringify({}));

      this.$router.push({ path: "/index" });
    },
    enterpriseUser() {
      this.$axios
        .post(`${SWNEWS_HOST}/api/enterpriseUser/index`, {})
        .then((res) => {
          if (res.data.code == 0) {
            this.enterpriseData = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    toEnterprise() {
      if (this.enterpriseData.status != 2) {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1520px;
  width: 100%;

  .logo {
    display: flex;
    align-items: center;

    .logo-img {
      height: 30px;
      margin-left: 38px;
    }
    .project-name {
      font-size: 22px;
      color: #ea0e0e;
      font-weight: 800;
    }
  }

  .user-profile-content {
    display: flex;
    align-items: center;

    .item {
      height: 100%;
      font-size: 26px;
      color: #dfe3ea;
      cursor: pointer;
    }

    .divider {
      margin: 0 32px;
    }

    .user-profile-body {
      display: flex;
      align-items: center;
      cursor: pointer;
      .user-avatar-container {
        height: 32px;
        width: 32px;
        margin-right: 12px;
        position: relative;
      }
      .user-avatar {
        height: 32px;
        width: 32px;
        border-radius: 16px;
      }
      .attestationIcon {
        width: 12px;
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }

    .certificationContainer {
      display: flex;
      height: 24px;
      background: #ff4646;
      border-radius: 12px;
      margin-left: 22px;
      padding: 0 4px 0 12px;
      align-items: center;
      cursor: pointer;

      p {
        font-size: 12px;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
      }

      img {
        height: 16px;
      }
    }
  }

  .certificationInfoContainer {
    /deep/.el-dialog__header {
      padding: 20px 32px;

      .el-dialog__title {
        font-size: 16px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        color: #333333;
        line-height: 22px;
      }
    }

    /deep/.el-dialog__body {
      padding: 10px 32px 41px 32px;

      .title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        margin-bottom: 20px;
      }

      .borderContainer {
        height: 255px;
        border-radius: 6px;
        border: 1px solid #dcdfe6;
        display: flex;
        padding: 28px 32px 0 32px;
        justify-content: space-between;

        div {
          flex: 1;

          .infoTitle {
            font-size: 16px;
            font-family: PingFang-SC-Heavy, PingFang-SC;
            font-weight: 800;
            color: #333333;
            line-height: 22px;
            margin-bottom: 10px;
          }

          .info {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
          }

          .qrCode {
            width: 118px;
            margin: 22px 0 0 117px;
          }

          .app {
            width: 198px;
            margin: 20px 0 0 43px;
          }
        }
      }
    }
  }
}

.user-dropdown {
  padding: 0 0 3px 0;

  .el-dropdown-menu__item {
    padding: 0 12px;

    .user-dropdown-item {
      border-bottom: 1px solid #e5e6eb;
      display: flex;
      align-items: center;
      padding: 4px 0;

      .user-dropdown-icon {
        height: 20px;
        margin-right: 8px;
      }

      .user-dropdown-item-text {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 400;
      }

      .notEnterprise {
        border-radius: 2px;
        background: #f5f5f5;
        color: #666666;
        font-family: "PingFang SC";
        font-size: 10px;
        font-weight: 400;
        line-height: 18px;
        padding: 0 4px;
        margin-left: 8px;
      }

      .isEnterprise {
        border-radius: 2px;
        background: #e8f3ff;
        color: #2589ff;
        font-family: "PingFang SC";
        font-size: 10px;
        font-weight: 400;
        line-height: 18px;
        padding: 0 4px;
        margin-left: 8px;
      }
    }

    &:nth-child(3) {
      .user-dropdown-item {
        border-bottom: 0;
      }
    }

    &:hover {
      background-color: #fff;
    }
  }
}
</style>
